import { useContext, createContext } from 'react'

export const FloatingCardContext = createContext({ handleClick: () => {} })
export const useFloatingCard = () => useContext(FloatingCardContext)
